import { render, staticRenderFns } from "./SystemPopup.vue?vue&type=template&id=c94b40cc&"
import script from "./SystemPopup.vue?vue&type=script&lang=js&"
export * from "./SystemPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiButton: require('/app/components/UI/UiButton.vue').default})
